(function(){
  'use strict';

  var COUNTRY_NAMES = ['Afghanistan','Albania','Algeria','Andorra','Angola','Antigua and Barbuda','Argentina','Armenia','Australia','Austria','Azerbaijan','Bahamas','Bahrain','Bangladesh','Barbados','Belarus','Belgium','Belize','Benin','Bhutan','Bolivia','Bosnia and Herzegovina','Botswana','Brazil','Brunei','Bulgaria','Burkina Faso','Burundi','Cabo Verde','Cambodia','Cameroon','Canada','Central African Republic','Chad','Chile','China','Colombia','Comoros','Congo','Costa Rica','Croatia','Cuba','Cyprus','Czech Republic','Democratic Republic of the Congo','Denmark','Djibouti','Dominica','Dominican Republic','Ecuador','Egypt','El Salvador','Equatorial Guinea','Eritrea','Estonia','Eswatini','Ethiopia','Fiji','Finland','France','Gabon','Gambia','Georgia','Germany','Ghana','Greece','Grenada','Guatemala','Guinea','Guinea-Bissau','Guyana','Haiti','Honduras','Hungary','Iceland','India','Indonesia','Iran','Iraq','Ireland','Israel','Italy','Ivory Coast','Jamaica','Japan','Jordan','Kazakhstan','Kenya','Kiribati','Kuwait','Kyrgyzstan','Laos','Latvia','Lebanon','Lesotho','Liberia','Libya','Liechtenstein','Lithuania','Luxembourg','Madagascar','Malawi','Malaysia','Maldives','Mali','Malta','Marshall Islands','Mauritania','Mauritius','Mexico','Micronesia','Moldova','Monaco','Mongolia','Montenegro','Morocco','Mozambique','Myanmar','Namibia','Nauru','Nepal','Netherlands','New Zealand','Nicaragua','Niger','Nigeria','North Korea','North Macedonia','Norway','Oman','Pakistan','Palau','Palestine','Panama','Papua New Guinea','Paraguay','Peru','Philippines','Poland','Portugal','Qatar','Romania','Russia','Rwanda','Saint Kitts and Nevis','Saint Lucia','Saint Vincent and the Grenadines','Samoa','San Marino','Sao Tome and Principe','Saudi Arabia','Senegal','Serbia','Seychelles','Sierra Leone','Singapore','Slovakia','Slovenia','Solomon Islands','Somalia','South Africa','South Korea','South Sudan','Spain','Sri Lanka','Sudan','Suriname','Sweden','Switzerland','Syria','Taiwan','Tajikistan','Tanzania','Thailand','Timor-Leste','Togo','Tonga','Trinidad and Tobago','Tunisia','Turkey','Turkmenistan','Tuvalu','Uganda','Ukraine','United Arab Emirates','United Kingdom','United States','Uruguay','Uzbekistan','Vanuatu','Vatican City','Venezuela','Vietnam','Yemen','Zambia','Zimbabwe'];
  var POPULAR_COUNTRIES = ['Kenya','United States','South Africa','Colombia','Mexico','Jamaica','Dominican Republic','Nigeria','India','Philippines','United Kingdom','Australia'];
  var JAMAICA_IMAGE = 'https://cdn.shopify.com/s/files/1/0682/1271/9765/files/JAMAICA.jpg?v=1729119196&width=900';
  var sent = Object.create(null);
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;

  function track(name, data){
    data = data || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({event:name, fahari_event:true, page_path:location.pathname}, data));
    if(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function'){
      try{ window.Shopify.analytics.publish(name, data); }catch(e){}
    }
  }
  function once(name, data){ if(sent[name]) return; sent[name]=true; track(name,data); }
  function countryUrl(country){ return '/search?q=' + encodeURIComponent((country || '').trim() + ' flag bracelet') + '&type=product'; }

  function injectBestsellerFix(){
    if(document.getElementById('fh-bestseller-display-fix-css')) return;
    var style = document.createElement('style');
    style.id = 'fh-bestseller-display-fix-css';
    style.textContent = [
      '.fh-home .fh-best-sellers{display:block!important;visibility:visible!important;opacity:1!important;content-visibility:visible!important;}',
      '.fh-home .fh-best-sellers .fh-head{display:flex!important;visibility:visible!important;opacity:1!important;}',
      '.fh-home .fh-best-sellers .fh-best-rail{display:grid!important;visibility:visible!important;opacity:1!important;grid-auto-flow:column!important;grid-auto-columns:minmax(260px,360px)!important;gap:24px!important;overflow-x:auto!important;scroll-snap-type:x mandatory!important;padding-bottom:16px!important;}',
      '.fh-home .fh-best-card{display:block!important;scroll-snap-align:start!important;color:inherit!important;}',
      '.fh-home .fh-best-img{position:relative!important;display:grid!important;place-items:center!important;aspect-ratio:1/1!important;background:#f3f0ea!important;overflow:hidden!important;}',
      '.fh-home .fh-best-img img{width:100%!important;height:100%!important;object-fit:contain!important;padding:18px!important;}',
      '@media (max-width:720px){.fh-home .fh-best-sellers{padding-left:20px!important;padding-right:20px!important;}.fh-home .fh-best-sellers .fh-head{display:block!important;}.fh-home .fh-best-rail{display:flex!important;grid-auto-flow:unset!important;grid-auto-columns:unset!important;gap:16px!important;overflow-x:auto!important;margin-left:0!important;margin-right:0!important;padding-left:0!important;padding-right:0!important;scroll-padding-left:0!important;}.fh-home .fh-best-card{flex:0 0 min(82vw,340px)!important;min-width:min(82vw,340px)!important;max-width:min(82vw,340px)!important;}.fh-home .fh-best-card h3{font-size:28px!important;line-height:1.08!important;}.fh-home .fh-best-meta{font-size:19px!important;line-height:1.45!important;}.fh-home .fh-price-now,.fh-home .fh-price-was{font-size:24px!important;}.fh-home .fh-save{font-size:20px!important;line-height:1.25!important;}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function fixJamaicaImage(){
    var cards = document.querySelectorAll('.fh-best-card');
    for(var i=0;i<cards.length;i++){
      var card = cards[i];
      var text = (card.textContent || '').toLowerCase();
      var href = (card.getAttribute('href') || '').toLowerCase();
      if(text.indexOf('jamaica') === -1 && href.indexOf('jamaica') === -1) continue;
      var img = card.querySelector('img');
      if(!img) continue;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = JAMAICA_IMAGE;
      img.alt = 'Jamaica Flag Bracelet';
      img.style.objectFit = 'contain';
      img.style.padding = '18px';
      img.onerror = function(){ this.onerror = null; this.src = JAMAICA_IMAGE; };
    }
  }

  function matchCountries(term){
    term = (term || '').trim().toLowerCase();
    if(!term) return POPULAR_COUNTRIES.slice(0,8);
    var starts = [], contains = [];
    for(var i=0;i<COUNTRY_NAMES.length;i++){
      var c = COUNTRY_NAMES[i], n = c.toLowerCase();
      if(n.indexOf(term) === 0) starts.push(c);
      else if(n.indexOf(term) > 0) contains.push(c);
      if(starts.length + contains.length >= 12) break;
    }
    return starts.concat(contains).slice(0,12);
  }

  function ensurePanel(input){
    var next = input.nextElementSibling;
    if(next && next.classList && next.classList.contains('fh-country-suggest-panel')) return next;
    var panel = document.createElement('div');
    panel.className = 'fh-country-suggest-panel';
    panel.setAttribute('role','listbox');
    input.insertAdjacentElement('afterend', panel);
    return panel;
  }

  function wireCountryInput(input){
    if(!input || input.dataset.fhCountryWired) return;
    input.dataset.fhCountryWired = 'true';
    input.setAttribute('placeholder','Search your country');
    var form = input.closest('form');
    var panel = ensurePanel(input);
    var lastTracked = '';
    function render(){
      var term = input.value || '';
      var countries = matchCountries(term);
      panel.innerHTML = countries.map(function(country){
        return '<a class="fh-country-suggestion" role="option" href="' + countryUrl(country) + '"><span>' + country + '</span><small>Shop ' + country + ' bracelet →</small></a>';
      }).join('');
      panel.style.display = countries.length ? 'grid' : 'none';
      if(term && term !== lastTracked){ lastTracked = term; track('fahari_country_search_type',{query:term.slice(0,40),matches:countries.length}); }
    }
    input.addEventListener('input', render, {passive:true});
    input.addEventListener('focus', render, {passive:true});
    input.addEventListener('keydown', function(e){
      if(e.key !== 'Enter') return;
      var q = input.value.trim();
      if(!q) return;
      e.preventDefault();
      var first = panel.querySelector('a');
      track('fahari_country_search_submit',{query:q});
      window.location.href = first ? first.href : countryUrl(q);
    });
    if(form){
      form.addEventListener('submit', function(e){
        var q = input.value.trim();
        if(!q) return;
        e.preventDefault();
        track('fahari_country_search_submit',{query:q});
        window.location.href = countryUrl(q);
      });
    }
  }

  function wireSearch(scope){
    var inputs = (scope || document).querySelectorAll ? (scope || document).querySelectorAll('input[type="search"], input[name="q"]') : [];
    for(var i=0;i<inputs.length;i++){
      var input = inputs[i];
      var label = ((input.getAttribute('placeholder') || '') + ' ' + (input.id || '') + ' ' + (input.name || '')).toLowerCase();
      if(label.indexOf('country') > -1 || label.indexOf('looking') > -1 || label.indexOf('search') > -1) wireCountryInput(input);
    }
  }

  function removeTermsGate(){
    var boxes = document.querySelectorAll('input[type="checkbox"]');
    for(var i=0;i<boxes.length;i++){
      var cb = boxes[i];
      var wrap = cb.closest('label, .checkbox, .agree-terms, [class*="term"], [class*="checkout"]');
      var text = ((wrap && wrap.textContent) || cb.getAttribute('name') || cb.id || '').toLowerCase();
      if(text.indexOf('term') > -1 || text.indexOf('agree') > -1 || text.indexOf('checkout') > -1 || text.trim() === ''){
        cb.checked = true;
        cb.required = false;
        cb.removeAttribute('required');
        if(wrap) wrap.classList.add('fh-hide-required-checkbox');
      }
    }
    var buttons = document.querySelectorAll('button[name="checkout"], input[name="checkout"], .cart__checkout-button, a[href="/checkout"], button.checkout');
    for(var j=0;j<buttons.length;j++){
      buttons[j].disabled = false;
      buttons[j].removeAttribute('disabled');
      buttons[j].classList.remove('disabled');
      buttons[j].setAttribute('aria-disabled','false');
    }
  }

  function cleanupLabelsOnly(){
    var labels = document.querySelectorAll('label, .product-meta, .product__text, .product-detail__meta, .rte');
    for(var i=0;i<labels.length;i++){
      var el = labels[i];
      if(el.children.length > 20) continue;
      var html = el.innerHTML;
      if(html.indexOf('Handmade in Kenya') > -1 || html.indexOf('Province') > -1 || html.indexOf('Call us free') > -1){
        el.innerHTML = html.replace(/Handmade in Kenya\s*•\s*/g,'').replace(/Handmade in Kenya/g,'').replace(/>Province</g,'>State / Province<').replace(/Call us free\./g,'<a href="/pages/contact-us">Contact us for help.</a>');
      }
    }
  }

  function productEnhancements(){
    if(location.pathname.indexOf('/products/') === -1) return;
    var title = document.querySelector('.product-detail__title, h1');
    if(title && !document.querySelector('.fh-product-review-snippet')){
      var snip = document.createElement('a');
      snip.href = '/pages/all-reviews';
      snip.className = 'fh-product-review-snippet';
      snip.innerHTML = '<span>★★★★★</span><strong>4.9/5 verified buyer reviews</strong><small>Customers love the color, fit, and gift-ready feel.</small>';
      title.insertAdjacentElement('afterend', snip);
    }
    var cards = document.querySelectorAll('[class*="question"], [class*="support"]');
    for(var i=0;i<cards.length;i++) if(/Have Questions\?/i.test(cards[i].textContent || '')) cards[i].innerHTML = '<a class="fh-contact-card-link" href="/pages/contact-us">Have questions?<span>Contact Fahari →</span></a>';
  }

  function suppressHeavyPopupsOnMobile(){
    if(!isMobile) return;
    var bad = document.querySelectorAll('.fake-order, fake-order, [id*="fake-order"], [class*="fake-order"], .fh-lead-modal');
    for(var i=0;i<bad.length;i++) bad[i].remove ? bad[i].remove() : bad[i].style.display='none';
  }

  function lazyMedia(){
    var imgs = document.querySelectorAll('main img:not([loading])');
    for(var i=0;i<imgs.length;i++) if(i > 1) imgs[i].setAttribute('loading','lazy');
    var iframes = document.querySelectorAll('main iframe:not([loading])');
    for(var j=0;j<iframes.length;j++) iframes[j].setAttribute('loading','lazy');
  }

  function bindClicks(){
    document.addEventListener('click', function(e){
      var add = e.target.closest('button[name="add"], [data-add-to-cart], .product-form__submit, form[action*="/cart/add"] button[type="submit"], a[href*="/cart/add"]');
      if(add) track('fahari_add_to_cart_click',{label:(add.textContent||'').trim().slice(0,80)});
      var checkout = e.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"], .cart__checkout-button, [href*="/checkout"]');
      if(checkout) track('fahari_checkout_start_click',{source:location.pathname});
    }, {capture:true, passive:true});
  }

  function bindFetchErrors(){
    if(!window.fetch || window.fetch.__fhWrapped) return;
    var originalFetch = window.fetch;
    function wrappedFetch(){
      var url = String(arguments[0] && arguments[0].url || arguments[0] || '');
      return originalFetch.apply(this,arguments).then(function(resp){
        if(url.indexOf('/cart/') > -1 && !resp.ok) track('fahari_cart_error',{url:url,status:resp.status});
        return resp;
      }).catch(function(err){
        if(url.indexOf('/cart/') > -1) track('fahari_cart_error',{url:url,message:String(err && err.message || err)});
        throw err;
      });
    }
    wrappedFetch.__fhWrapped = true;
    window.fetch = wrappedFetch;
  }

  function initCritical(){
    once('fahari_page_view',{page_type:document.body.className || ''});
    if(location.pathname.indexOf('/products/') > -1) once('fahari_product_view',{product_path:location.pathname});
    injectBestsellerFix();
    fixJamaicaImage();
    wireSearch(document);
    bindClicks();
    bindFetchErrors();
  }

  function initDeferred(){
    removeTermsGate();
    cleanupLabelsOnly();
    productEnhancements();
    lazyMedia();
    suppressHeavyPopupsOnMobile();
    injectBestsellerFix();
    fixJamaicaImage();
  }

  function scheduleDeferred(){
    var run = function(){ initDeferred(); };
    if('requestIdleCallback' in window) requestIdleCallback(run, {timeout: isMobile ? 2200 : 1200});
    else setTimeout(run, isMobile ? 1600 : 700);
  }

  function observeSmall(){
    if(!window.MutationObserver) return;
    var target = document.querySelector('cart-drawer, .cart-drawer, .drawer, .search-drawer, .fh-best-sellers') || document.body;
    var runs = 0, timer = 0;
    var mo = new MutationObserver(function(){
      if(runs > (isMobile ? 5 : 8)){ mo.disconnect(); return; }
      clearTimeout(timer);
      timer = setTimeout(function(){ runs++; wireSearch(target); removeTermsGate(); suppressHeavyPopupsOnMobile(); injectBestsellerFix(); fixJamaicaImage(); }, 350);
    });
    mo.observe(target, {childList:true, subtree:true});
  }

  function boot(){ initCritical(); scheduleDeferred(); observeSmall(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  window.addEventListener('load', function(){ setTimeout(initDeferred, isMobile ? 1800 : 400); }, {once:true});
  document.addEventListener('shopify:section:load', function(e){ wireSearch(e.target); scheduleDeferred(); injectBestsellerFix(); fixJamaicaImage(); });
})();